module.exports = __webpack_public_path__ + "static/media/Gold-Glitter-Background.bcc1434d.jpg";